import { format } from 'date-fns'

import { AnalyticsFiltersParams } from '@img-arena/consoles-api-streaming'

import { Filters } from './historicalStatistics.store.types'

export const dateToString = (date: Date | null) => (date && format(date, 'yyyy-MM-dd')) || undefined

export const filtersToQueryParams = (filters: Filters): AnalyticsFiltersParams => {
  const {
    period,
    country,
    operators,
    usSubdivision,
    caSubdivision,
    cdn,
    userAgent,
    content,
    platform
  } = filters

  const { fromDate, toDate } = period
  const { sport, property, tournament } = content || {}

  const subdivision =
    (usSubdivision.length && usSubdivision) || (caSubdivision.length && caSubdivision) || undefined

  return {
    fromDate: dateToString(fromDate),
    toDate: dateToString(toDate),
    countryCode:
      country
        ?.map((country) => country.iso2)
        .join(',')
        .toUpperCase() || undefined,
    sportId: sport?.id,
    propertyId: property?.id,
    tournamentId: tournament?.id,
    operatorId: operators?.map((operator) => operator.id).join(',') || undefined,
    subdivision: subdivision?.map((subdivision) => subdivision.code).join(',') || undefined,
    cdn: cdn?.toLowerCase(),
    userAgent: userAgent?.value.toLowerCase(),
    platform: platform?.value.toLowerCase()
  }
}
